import axios from "axios";
import md5 from "md5";
import Cookies from "js-cookie";
import {
	captureError,
	addApiBreadcrumb,
	logApiErrorToSentry,
} from "../services/util";

export const rawAxios = axios.create();

export let jwtToken = localStorage.getItem("jwtToken");

export let accessToken = "";

export const userId = Cookies.get("userEmail")
	? md5(Cookies.get("userEmail").toLowerCase().trim())
	: "";

let currentUserDetails = null;

export const setJwtToken = (token) => {
	jwtToken = token;
};

export const setAccessToken = (token) => {
	accessToken = token;
};

export const setCurrentUserDetails = (user) => {
	currentUserDetails = user;
};

const getCurrentUserEmail = () =>
	currentUserDetails?.attributes["custom:userId"] || "";

// --- Request Interceptor ---
axios.interceptors.request.use(
	async (config) => {
		try {
			if (jwtToken && jwtToken !== "") {
				if (!config.headers["authorization"] && !config.headers["Authorization"]) {
					config.headers["Authorization"] = `Bearer ${jwtToken}`;
				}
			}
			config.headers["Accept-Encoding"] = "gzip, compress, deflate, br";
			return config;
		} catch (err) {
			captureError(err, { tags: { phase: "request" } });
			return Promise.reject(err);
		}
	},
	(error) => {
		captureError(error, { tags: { phase: "request" } });
		return Promise.reject(error);
	}
);

// --- Response Interceptor ---
axios.interceptors.response.use(
	(response) => {
		// Let axios handle non-2xx statuses via error interceptor
		if (response?.data?.error || response?.data?.statusCode >= 400) {
			const error = new Error(
				response?.data?.errorMessage ||
				response?.data?.error ||
				response?.data?.message ||
				response?.data?.message?.message ||
				"Something went wrong!"
			);

			logApiErrorToSentry(error, {
				status: response?.status,
				url: response?.config?.url,
				method: response?.config?.method,
				requestData: response?.config?.data,
				responsePayload: response?.data,
				userId: getCurrentUserEmail()
			});

			throw error;
		}
		return response;
	},
	(error) => {
		addApiBreadcrumb(error);

		if (error.response) {
			error.message =
				error?.response?.data?.error || "Something went wrong!";

			if ([401, 403, 500].includes(error?.response?.status)) {
				logApiErrorToSentry(error, {
					status: error?.response?.status,
					url: error?.config?.url,
					method: error?.config?.method,
					requestData: error?.config?.data,
					responsePayload: error?.response?.data,
					userId: getCurrentUserEmail()
				});
			}
		} else {
			// Network/unexpected error
			captureError(error, {
				tags: {
					service: "axios",
					env: process?.env?.NODE_ENV,
					type: "network_error",
				},
			});
		}
		return Promise.reject(error);
	}
);

export default axios;
